import axios from 'axios';

export const loginUser = async (body) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/sessions/login`, body);

export const googleLoginUser = async (body) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/sessions/google`, body);

export const otpLoginUser = async (body) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/sessions/otp`, body);

export const voiceOtpLoginUser = async (body) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/sessions/otp/ivr`, body);

export const otpVerifyUser = async (body) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/sessions/otp/verify`, body);

export const destroyAllSessions = async (body) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/sessions/logout`, body);

export const destroyOneSession = async (body) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/sessions/logout/session`, body);
